"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var VideoQualitySettings = function VideoQualitySettings(videoWidth, videoHeight, videoFrameRate, videoMaxBandwidthKbps) {
  _classCallCheck(this, VideoQualitySettings);

  this.videoWidth = videoWidth;
  this.videoHeight = videoHeight;
  this.videoFrameRate = videoFrameRate;
  this.videoMaxBandwidthKbps = videoMaxBandwidthKbps;
};

exports.default = VideoQualitySettings;